import { EpicRefined } from 'interfaces/middleware'
import { AdvisorPublicActions, GetPublicAdvisorAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMap, map } from 'rxjs/operators'
import { SEARCH_ADVISOR_PUBLIC_URL } from 'interfaces/ajax'
import { of, merge } from 'rxjs'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { NOT_FOUND_STATUS_CODE } from 'constants/ajax'
import { pushActionCreator } from 'actions/navigationActions'


export const getPublicAdvisorEpic: EpicRefined<AdvisorPublicActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetPublicAdvisorAction.type),
  mergeMap((action) => {
    return get(SEARCH_ADVISOR_PUBLIC_URL, { username: action.payload.params.username }).pipe(
      map(({ response }) => action.success(response)),
      ajaxCatch((error) => {
        const failAction = action.fail({ errorCode: error.status })
        if (error.status === NOT_FOUND_STATUS_CODE) {
          return merge(
            of(failAction),
            of(pushActionCreator('/dashboard')),
            // of(setUnexpectedErrorActionCreator('page-not-found')),
          )
        }
        return of(failAction)
      }),
    )
  }),
)

